import { createStore } from "vuex";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import axios from 'axios';

export default createStore({
  state: {
    isPinned: true,
    sidebarType: "bg-gray-800",
    isRTL: false,
    color: "success",
    showSidenav: true,
    showFooter: true,
    isDarkMode: false,
    username: null,
    userName: null,
    bootstrap
  },
  mutations: {
    setIsPinned(state, payload) {
      state.isPinned = payload;
    },
    color(state, payload) {
      state.color = payload;
    },
    setLoggedIn(state, status) {
      state.loggedIn = status;
    },
    async setUsername(state, username) {
      state.username = username; // 사용자 이름 업데이트 뮤테이션
    },
    async setUserFullName(state, userName) {

      state.userName = userName;
    }
  },
  actions: {
    setColor({ commit }, payload) {
      commit("color", payload);
    },
    async checkSessionStatus({ commit }) {
      try {
        const response = await axios.get('/api/session-status');
        commit('setLoggedIn', response.data.loggedIn);
        if (response.data.loggedIn) {
          await commit('setUsername', response.data.username); // 세션 상태에 따라 사용자 이름도 설정
          await commit('setUserFullName', response.data.userName); // 세션 상태에 따라 사용자 이름도 설정
        }
      } catch (error) {
        console.error('Error checking session status:', error);
      }
    }
  },
  getters: {}
});
